import './CartHeader.css';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Heart } from 'lucide-react';
import LoginModal from '../LoginModal/LoginModal';

const FaveHeader = () => {
    const isAuthenticated = useSelector((state) => state.service.isAuthenticated);
    const favouriteAmount = useSelector((state) => state.favourite.favouriteAmount);
    const [isOpen, setIsOpen] = useState(false);

    if (isAuthenticated) return <a className="mg-header-top-actions__link cursor-pointer" href="/favourite" aria-label="Избранное"><Heart aria-hidden="true" />{favouriteAmount > 0 && <span className="cart-count">{favouriteAmount}</span>}</a>;

    return <><button type="button" className="mg-header-top-actions__link cursor-pointer" onClick={() => setIsOpen(true)} aria-label="Избранное"><Heart aria-hidden="true" /></button><LoginModal isOpen={isOpen} setIsOpen={setIsOpen} /></>;
};

export default FaveHeader;
